// Status palette re-pointed onto the design system's off-grid feedback colors:
// magenta = complete/ok, amber = needs attention, muted = revoked. The HR-zone
// spectrum (green/red) is reserved and must never be borrowed for chrome.
const styles = {
  complete:  "bg-primary/10 text-primary dark:text-[#FF8FBF] border border-primary/30",
  incomplete:"bg-amber-500/10 text-amber-400 border border-amber-500/30 border-dashed",
  pending:   "bg-amber-500/10 text-amber-400 border border-amber-500/30 border-dashed",
  accepted:  "bg-primary/10 text-primary dark:text-[#FF8FBF] border border-primary/30",
  revoked:   "bg-muted text-muted-foreground border border-border line-through",
  active:    "bg-foreground/10 text-foreground border border-foreground/20",
  owner:     "bg-primary text-primary-foreground font-bold",
  admin:     "bg-secondary text-secondary-foreground font-bold",
  neutral:   "bg-muted text-muted-foreground border border-border",
};

export default function Pill({ variant = "neutral", children, testId }) {
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center font-mono text-[10px] px-2 py-0.5 rounded-sm uppercase tracking-wider ${styles[variant] || styles.neutral}`}
    >
      {children}
    </span>
  );
}
